import React, { FC, ReactElement } from 'react';
import { Input } from 'src/domains/common/components/input/input';
import { Select } from 'src/domains/common/components/select/select';
import { CasinoGamesPicker } from './CasinoGamesPicker';
import { observer } from 'mobx-react-lite';
import { useCommon } from 'src/AppState/Common';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { formatNumericInput } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.helpers';
import { ResultsMultiSelect } from 'src/domains/casino/webview/bonus-engine/campaign/action-conditions/ResultsMultiSelect';

interface CasinoSectionsType {
    campaignId?: string;
}

export const CasinoSections: FC<CasinoSectionsType> = observer(({ campaignId }): ReactElement => {
    const common = useCommon();
    const { generalDetailsState, actionConditionsState, editionDisabled } = CampaignCreatorState.get(
        common,
        campaignId
    );
    const { allStakeTypeOptions, criteriaForm, numberOfSpins, moneteryValue, casinoResultForm } =
        actionConditionsState.casinoSelectionsState;
    return (
        <>
            <section
                data-test='casino-stake-criteria'
                className='flex flex-col gap-6'
            >
                <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>Stake Criteria</h2>
                <div className='grid grid-cols-2 gap-4'>
                    <Select
                        dataTest='stake-type-dropdown'
                        label='Stake Type'
                        placeholder='Select'
                        values={allStakeTypeOptions}
                        formInputState={criteriaForm}
                        errors={criteriaForm.errorsForView}
                        disabled={editionDisabled}
                    />
                    {criteriaForm.value === 'min-spins' ? (
                        <Input
                            label='Minimum Number of Rounds'
                            placeholder='Type'
                            formInputState={numberOfSpins}
                            description='Enter a number. Minimum value is 1'
                            errors={numberOfSpins.errorsForView}
                            disabled={editionDisabled}
                        />
                    ) : (
                        <Input
                            label='Minimum Monetary Value'
                            placeholder='Type'
                            formInputState={moneteryValue}
                            onBlur={() => formatNumericInput(moneteryValue)}
                            description='Enter a number. Minimum value is £1.00'
                            errors={moneteryValue.errorsForView}
                            disabled={editionDisabled}
                        />
                    )}
                    {generalDetailsState.campaignTypeForm.value === 'settlement' ? (
                        <ResultsMultiSelect
                            formInputState={casinoResultForm}
                            disabled={editionDisabled}
                        />
                    ) : null}
                </div>
            </section>
            <section
                data-test='casino-game-picker'
                className='flex flex-col gap-6'
            >
                <CasinoGamesPicker
                    campaignId={campaignId}
                    disabled={editionDisabled}
                />
            </section>
        </>
    );
});
